import { cva } from 'class-variance-authority';
import type { ToggleButtonGroupSizes } from '../../types';

export const getButtonGroupButtonClassName = cva(
  'flex flex-row items-center justify-center !border-none',
  {
    variants: {
      size: {
        xs: 'px-sm gap-xs h-5 text-xxs !rounded-xs',
        sm: 'px-sm py-xxs gap-xs h-6 text-xs !rounded-xs',
        md: 'px-lg py-xs gap-sm h-7 text-sm !rounded-sm',
        lg: 'px-xl py-md gap-sm h-9 text-sm !rounded-md',
      } satisfies Record<ToggleButtonGroupSizes, string>,
      selected: {
        true: 'shadow-sm',
        false: 'bg-inherit text-tertiary',
      },
      disabled: {
        true: '',
        false: '',
      },
      color: {
        neutral: '',
        brand: '',
      },
    },
    compoundVariants: [
      {
        selected: false,
        disabled: false,
        color: 'neutral',
        class: ['hover:!bg-primary text-tertiary'],
      },
      {
        selected: false,
        disabled: false,
        color: 'brand',
        class: ['hover:!bg-quaternary text-tertiary'],
      },
      {
        selected: true,
        disabled: false,
        color: 'neutral',
        class: ['bg-primary hover:!bg-primary'],
      },
      {
        selected: true,
        disabled: false,
        color: 'brand',
        class: ['bg-brand-solid text-white hover:!bg-brand-solid'],
      },
      {
        selected: false,
        disabled: true,
        class: ['text-disabled hover:!bg-inherit'],
      },
      {
        selected: true,
        disabled: true,
        class: ['text-disabled bg-disabled'],
      },
    ],
  },
);

export const getButtonGroupIconButtonClassName = cva(
  'flex flex-row items-center justify-center !border-none',
  {
    variants: {
      size: {
        xs: 'px-xs h-5 !rounded-xs',
        sm: 'px-sm py-xxs h-6 !rounded-xs',
        md: 'px-md py-xs h-7 !rounded-sm',
        lg: 'px-lg py-md h-9 !rounded-md',
      } satisfies Record<ToggleButtonGroupSizes, string>,
      selected: {
        true: 'shadow-sm',
        false: 'bg-inherit text-tertiary',
      },
      color: {
        neutral: '',
        brand: '',
      },
      disabled: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        selected: false,
        disabled: false,
        color: 'neutral',
        class: ['hover:!bg-primary text-tertiary'],
      },
      {
        selected: false,
        disabled: false,
        color: 'brand',
        class: ['hover:!bg-quaternary text-tertiary'],
      },
      {
        selected: true,
        disabled: false,
        color: 'neutral',
        class: ['bg-primary hover:!bg-primary'],
      },
      {
        selected: true,
        disabled: false,
        color: 'brand',
        class: ['bg-brand-solid text-white hover:!bg-brand-solid'],
      },
      {
        selected: false,
        disabled: true,
        class: ['text-disabled'],
      },
      {
        selected: true,
        disabled: true,
        class: ['text-disabled bg-disabled'],
      },
    ],
  },
);
